import React, { useEffect, useState } from 'react'

import { doc, getDoc } from 'firebase/firestore'

import { BonusFilter } from '../../..'
import { firestore } from '../../../../firebase/firebaseConfig'
const Admin = () => {
  const [filterOptions, setFilterOptions] = useState<string[] | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      // TODO: replace with
      // const menu = await guardedCall(() => getDoc(doc(firestore, 'lists', 'adminBonusMenu')))
      const docRef = doc(firestore, 'lists', 'adminBonusMenu')
      const menu = await getDoc(docRef)

      if (menu.exists()) {
        setFilterOptions(menu.data().items as string[])
      }
    }

    fetchData()
  }, [])

  return <>{filterOptions && <BonusFilter filterOptions={filterOptions} />}</>
}

export default Admin
